<template>
    <div class="image-upload-button">
        <input type="file" ref="imagePicker" accept="image/x-png,image/gif,image/jpeg" @change="upload"/>
        <el-button type="warning" size="medium" @click.prevent="trigger">
            <i class="el-icon-picture-outline"></i>이미지 추가
        </el-button>
    </div>
</template>

<script>
    export default {
        name: 'ImageUploadButton',
        props: {
            onUpload: Function,
            maxSize: Number,    //MB
        },
        methods: {
            trigger() {
                this.$refs.imagePicker.click();
            },
            upload() {
                const file = this.$refs.imagePicker.files[0];

                if (/\.(jpe?g|png)$/i.test(file.name) && file.size < 1024 * 1024 * this.maxSize) {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => this.onUpload(reader.result);
                    reader.onerror = () => this.$message.error('업로드 중 문제가 발생하였습니다. 잠시 후 다시 시도해주세요.');
                } else {
                    this.$message.error(`${this.maxSize}MB 이하의 jpg, jpeg, png 파일만 업로드 가능합니다.`);
                }

                this.$refs.imagePicker.value = '';
            },
        },
    };
</script>

<style lang="scss" scoped>
    .image-upload-button {
        i {
            font-size: 12px;
            margin-right: 5px;
        }

        input {
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: -1px;
            overflow: hidden;
            clip: rect(0, 0, 0, 0);
            border: 0 none;
        }
    }
</style>